import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'flag',
})
export class FlagTypePipe implements PipeTransform {
  transform(value: any, type?: any): any {
    let flagName;
    if(value){
      const realValue = value.replace(/[^a-zA-Z]/g, "").toLowerCase()
      const relType =  type.replace(/[^a-zA-Z]/g, "").toLowerCase()

      const hasType = ['single', 'mono', 'flat', 'monooutline', 'flatrounded', 'adquirente'].indexOf(relType) != -1
      const hasFlag = ['alipay', 'amex', 'americanexpress', 'diners', 'discover', 'elo', 'hipercard', 'jcb', 'maestro', 'mastercard', 'paypal', 'unionpay', 'visa', 'visaelectron', 'getnet', 'cielo', 'mp', 'mercadopago', 'pagseguro', 'stone', 'rede', 'default'].indexOf(realValue) != -1
      const hasAcquirer = ['getnet', 'cielo', 'mp', 'mercadopago', 'pagseguro', 'stone', 'rede'].indexOf(realValue) != -1

      if(type && !hasType){
        return 'not-found'
      }
      if(type && !hasFlag){
        return 'single-default'
      }
      if(type && !hasAcquirer && relType === 'adquirente'){
        return 'acquirer-default'
      }
      switch (relType) {
        case 'single':
          flagName = `single-${realValue}`;
          break;
        case 'mono':
          flagName = `mono-${realValue}`;
          break;
        case 'flat':
          flagName = `flat-${realValue}`;
          break;
        case 'monooutline':
          flagName = `mono-outline-${realValue}`;
          break;
        case 'flatrounded':
          flagName = `flat-rounded-${realValue}`;
          break;

        case 'adquirente':
          flagName = `acquirer-${realValue}`;
          break;

        default:
          flagName = `single-default`;
          break;
      }

    }else{
      if(type !== 'adquirente'){
        flagName = 'single-default';
      }else{
        flagName = 'acquirer-default';
      }
    }
    return flagName;
  }
}
